import Img from "gatsby-image"

import React, { Component } from "react"

import * as projectStyles from "../../styles/Components/projectTile.module.css"

export default class ProjectsTile extends Component {
  render() {
    return (
      <div className={`row ${projectStyles.maindiv}`}>
        <div className={projectStyles.imgDiv}>
          <div className={projectStyles.midImgDiv}>
            <Img
              className={projectStyles.img}
              fluid={this.props.fluid}
              alt={this.props.name}
              title={this.props.name}
            />
          </div>
        </div>
        <div className={projectStyles.sideDiv}>
          <a href={this.props.url}>
            <div className={projectStyles.name}>{this.props.name}</div>
          </a>
          <div className={projectStyles.desc}>{this.props.desc}</div>
          {this.props.techStack.map(tech => (
            <div className={projectStyles.techBtn} key={tech.techText}>
              <a href={tech.url}>
                <div className={`row ${projectStyles.row} `}>
                  <div className={projectStyles.techText}>{tech.name}</div>
                  <div className={projectStyles.techImg}>
                    <Img
                      fluid={tech.img.childImageSharp.fluid}
                      alt={tech.name}
                      title={tech.name}
                    />
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
        <div className={projectStyles.linkDiv}>
          <div className={projectStyles.midLinkDiv}>
            <div className={projectStyles.linkRow}>
              {this.props.urls.map(url => (
                <div className={projectStyles.linkBtn} key={url.name}>
                  <a href={url.url}>
                    <div className={`row ${projectStyles.row} `}>
                      <div className={projectStyles.linkImg}>
                        <Img
                          fluid={url.img.childImageSharp.fluid}
                          alt={url.name}
                          title={url.name}
                        />
                      </div>
                      <div className={projectStyles.linkText}>{url.name}</div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
